// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__btS88","gfeWrapper":"CalendarEvent_gfeWrapper__2S-Et"};